import React from 'react';
import LoginLayout from '../Layouts/LoginLayout';
import BookingsContent from '../Components/Booking/BookingsContent';

export default function Bookings() {
  return (
    <LoginLayout>
        <BookingsContent />
    </LoginLayout>
  )
}
